import React from "react"

import { NewProjectOverlay } from "./NewProjectOverlay"
import { useNewProjectOverlayModel } from "./model/useNewProjectOverlayModel"

export type NewProjectOverlayPayload = {
  defaultValue?: { id?: string | undefined; title?: string | undefined }
  navigateAfterSubmit?: boolean
}

export interface NewProjectOverlayConnectorProps {
  payload: NewProjectOverlayPayload
}

export const NewProjectOverlayConnector = React.memo(
  (props: NewProjectOverlayConnectorProps) => (
    <NewProjectOverlay {...useNewProjectOverlayModel(props)} />
  )
)

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    NEW_PROJECT_OVERLAY: NewProjectOverlayPayload
  }
}
